<sag-ui-button color="tertiary" [icon]="'region'" (click)="changeLanguage()">
  {{ selectedLanguage.toUpperCase() }}
</sag-ui-button>
